import Constants from "expo-constants"

export const s3ImageDomain =
  Constants.expoConfig?.extra?.env == "prd"
    ? "https://ra9ra9-contents-bucket-prod.s3.ap-northeast-1.amazonaws.com/"
    : Constants.expoConfig?.extra?.env == "stg"
    ? "https://ra9ra9-contents-bucket-stg.s3.ap-northeast-1.amazonaws.com/"
    : "https://ra9ra9-contents-bucket-dev.s3.ap-northeast-1.amazonaws.com/"
